export default __webpack_public_path__ + "static/media/polls.b4749bec.svg";